import React from "react";
import { Link } from "react-router-dom";

import { makeStyles } from "@material-ui/core";

import "./Footer.scss";

const links = [
  {
    title: "Terms",
    link: "/terms",
  },
  {
    title: "Privacy & Policy",
    link: "/privacy",
  },
  {
    title: "Help Center",
    link: "/",
  },
];

const useStyles = makeStyles((theme) => ({
  links: {
    color: `${theme.palette.text.primary} !important`,
  },
}));
function Footer() {
  const classes = useStyles();
  return (
    <div id="footer">
      <ul>
        {links.map((item, index) => (
          <li key={index}>
            <Link to={item.link} className={classes.links}>
              {item.title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Footer;
